import { useEffect, useState } from 'react'

require('intersection-observer')

type UseOnScreenOptions = {
  threshold?: number | number[]
  rootMargin?: string
  root?: Element | null
}

export default function useOnScreen(
  ref: React.RefObject<Element>,
  options: UseOnScreenOptions = {}
) {
  const [isIntersecting, setIntersecting] = useState(false)

  useEffect(() => {
    let observer: IntersectionObserver | null = null
    let timeoutId: NodeJS.Timeout | null = null
    let retryCount = 0
    const MAX_RETRIES = 10

    const setupObserver = () => {
      if (ref.current) {
        observer = new IntersectionObserver(
          ([entry]) => {
            setIntersecting(entry.isIntersecting)
          },
          {
            threshold: options.threshold ?? 0,
            rootMargin: options.rootMargin ?? '0px',
            root: options.root ?? null,
          }
        )

        observer.observe(ref.current)
      } else if (retryCount < MAX_RETRIES) {
        retryCount++
        // Retry in next tick if ref is not ready yet
        timeoutId = setTimeout(setupObserver, 10)
      }
    }

    setupObserver()

    return () => {
      if (timeoutId) {
        clearTimeout(timeoutId)
      }
      if (observer) {
        observer.disconnect()
      }
    }
  }, [ref.current, options.threshold, options.rootMargin, options.root]) // eslint-disable-line react-hooks/exhaustive-deps

  return isIntersecting
}
